import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faMinus } from '@fortawesome/pro-light-svg-icons';
import styles from './index.module.scss';

interface IProps {
  value: boolean;
  title: string;
}

export const SsoConfigInfoItem: FC<IProps> = props => {
  const { value, title } = props;

  return (
    <div className={styles.container}>
      <span className={styles.title}>{title}</span>
      <FontAwesomeIcon icon={value ? faCheck : faMinus} className={styles.value} />
    </div>
  );
};

export default SsoConfigInfoItem;
